import type { M2Basis } from '@/utils/m2Basis';
import { m2BasisNotice } from '@/utils/m2Basis';

/**
 * The one line that says which m² the percentage on screen was calculated on,
 * shown wherever a vordering percentage is proposed. Renders nothing in the
 * normal case (a legplan that agrees with the offerte).
 *
 * `danger` is red on purpose: both cases it covers — no basis at all, and a
 * legplan that is far off the sold surface — have produced a wrong invoice.
 */
export function M2BasisNotice({ basis }: { basis: M2Basis }) {
  const notice = m2BasisNotice(basis);
  if (!notice) return null;
  const danger = notice.tone === 'danger';
  return (
    <p
      role="alert"
      className={`flex items-start gap-1.5 rounded-lg border px-2.5 py-1.5 text-[11px] font-semibold ${
        danger
          ? 'border-red-300 bg-red-50 text-red-700'
          : 'border-amber-300 bg-amber-50 text-amber-800'
      }`}
    >
      <span aria-hidden="true">⚠</span>
      <span>{notice.text}</span>
    </p>
  );
}
